// removed by extract-text-webpack-plugin
module.exports = {"vpSidebarTitle":"vpSidebarTitle___2xYYM","vpDrawerLink":"vpDrawerLink___vDc0N","vpActiveLink":"vpActiveLink___IDphd"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/SidebarMenu.module.less
// module id = 1404
// module chunks = 33